import React from "react";
import PropTypes from "prop-types";
import { Text, Stack, TextLink, Button } from "@chaser/components";
import { formatDate } from "../../../../../util/time";

const getExpiredTrialModuleTitle = (module) => {
  const moduleLabel = module?.moduleName || "Module";
  return moduleLabel;
};

const getTrialEndLabelForModule = (module) => {
  const trialEndDate = module?.trialEndsAt
    ? new Date(module.trialEndsAt)
    : null;
  if (!trialEndDate || Number.isNaN(trialEndDate.getTime())) {
    return "Trial expired";
  }

  return `Trial expired ${formatDate(trialEndDate, { month: "long" })}`;
};

const ExpiredTrialsSection = ({
  expiredTrialModules,
  moduleSummaryIds,
  onOpenModule,
  onSubscribeNow,
  style,
}) => {
  if (!expiredTrialModules.length) return null;

  return (
    <Stack className={style.expiredTrialsBox}>
      <Text fontSize="small">MODULES WITH EXPIRED TRIALS</Text>
      <div className={style.expiredTrialsList}>
        {expiredTrialModules.map((module) => (
          <div key={module.id} className={style.expiredTrialRow}>
            <Stack gap="xsmall">
              {moduleSummaryIds.has(module.id) ? (
                <TextLink monochrome onClick={() => onOpenModule(module.id)}>
                  {getExpiredTrialModuleTitle(module)}
                </TextLink>
              ) : (
                <Text>{getExpiredTrialModuleTitle(module)}</Text>
              )}
              <Text color="Mid Neutral 1" className={style.lineSubtitle}>
                {getTrialEndLabelForModule(module)}
              </Text>
            </Stack>
            <div className={style.expiredTrialActions}>
              <Button
                size="narrow"
                appearance="secondary"
                onClick={() => onSubscribeNow(module.id)}
                className={style.subscribeButton}
              >
                Subscribe now
              </Button>
              <span className={style.expiredStatusPill}>Expired</span>
            </div>
          </div>
        ))}
      </div>
    </Stack>
  );
};

ExpiredTrialsSection.propTypes = {
  expiredTrialModules: PropTypes.arrayOf(PropTypes.object).isRequired,
  moduleSummaryIds: PropTypes.instanceOf(Set).isRequired,
  onOpenModule: PropTypes.func.isRequired,
  onSubscribeNow: PropTypes.func.isRequired,
  style: PropTypes.object.isRequired,
};

export default ExpiredTrialsSection;
